import { render, staticRenderFns } from "./zp.vue?vue&type=template&id=2f183198&scoped=true"
import script from "./zp.vue?vue&type=script&lang=js"
export * from "./zp.vue?vue&type=script&lang=js"
import style0 from "./zp.vue?vue&type=style&index=0&id=2f183198&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f183198",
  null
  
)

export default component.exports